import { immer } from '../middelware/immer'
import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export type Store = {
  warnLedger: boolean
  hideWarnLedger: () => void
  algoUsd: number
  setAlgoUsd: (algoUsd: number) => void
  isDebugEnabled: boolean
  setIsDebugEnabled: (isDebuggingEnabled: boolean) => void
  bypass: string
  setBypass: (bypass: string) => void
  hasAcceptedTerms: boolean
  setHasAcceptedTerms: (hasAcceptedTerms: boolean) => void
}

export const useStore = create<Store>(
  devtools(
    persist(
      immer((set) => ({
        warnLedger: true,
        hideWarnLedger: () =>
          set((state) => {
            state.warnLedger = false
          }),

        algoUsd: 0,
        setAlgoUsd: (algoUsd) =>
          set((state) => {
            state.algoUsd = algoUsd
          }),

        isDebugEnabled: false,
        setIsDebugEnabled: (isDebuggingEnabled) =>
          set((state) => {
            state.isDebugEnabled = isDebuggingEnabled
          }),

        bypass: '',
        setBypass: (bypass) =>
          set((state) => {
            state.bypass = bypass
          }),

        hasAcceptedTerms: false,
        setHasAcceptedTerms: (hasAcceptedTerms) =>
          set((state) => {
            state.hasAcceptedTerms = hasAcceptedTerms
          })
      })),
      {
        name: 'nfd-store',
        version: 1
      }
    ),
    { name: 'local-storage' }
  )
)
